// unassigned-customers.component.ts
import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DataserviceService } from '../dataservice.service';
import { UpdateRepModalComponent } from '../update-rep-modal/update-rep-modal.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
@Component({
  selector: 'app-unassigned-customers',
  templateUrl: './unassigned-customers.component.html',
  styleUrls: ['./unassigned-customers.component.css']
})
export class UnassignedCustomersComponent implements OnInit {
  customers: any[] = [];
  filteredCustomers: any[] = [];
  users: any[] = [];
  currentUser: any;
  isLoading = false;
  selectedUser: any = null;
  selectedCustomer: any = null;
  showAssignModal = false;
  searchValue: string = '';

  constructor(
    private dataService: DataserviceService,
    private message: NzMessageService,
    private modal: NzModalService
  ) {}

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.loadUnassignedCustomers();
  }

  loadUnassignedCustomers() {
    this.isLoading = true;
    this.dataService.getData('work-order/unassigned')
      .subscribe({
        next: (res: any) => {
          this.customers = res;
          this.filteredCustomers = [...this.customers];
          this.isLoading = false;
        },
        error: (err) => {
          this.message.error('Failed to load unassigned customers');
          this.isLoading = false;
        }
      });
  }

  search(): void {
    this.filteredCustomers = this.customers.filter((customer) => 
      customer.temp_rep_name.toLowerCase().includes(this.searchValue.toLowerCase())
    );
  }

  resetSearch(): void {
    this.searchValue = '';
    this.filteredCustomers = [...this.customers];
  }

  showAssignUserModal(customer: any) {
    const modal = this.modal.create({
      nzContent: UpdateRepModalComponent, 
      nzClosable: false,
      nzMaskClosable: false,
      nzFooter: null,
      nzData: {
        wo: customer,
        unassignedData: {
          temp_rep_name: customer.temp_rep_name,
          company: customer.company,
        }
      }
    });

    modal.afterClose.subscribe((data: any) => {
      if (data) {
        this.loadUnassignedCustomers();
      }
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { sort } = params;
    const currentSort = sort.find((s: any) => s.value !== null);
  
    if (currentSort) {
      const { key, value } = currentSort;
      this.filteredCustomers = [...this.filteredCustomers].sort((a, b) => {
        let valA = a[key];
        let valB = b[key];
  
        if (key === 'customer_name') {
          valA = `${a.first_name} ${a.last_name}`;
          valB = `${b.first_name} ${b.last_name}`;
        }
  
        return value === 'ascend' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        
      });
    }
  }
}